export default __webpack_public_path__ + "static/media/xacademy for LM 1.55ba433d.svg";